import React, { useEffect } from "react";
import Hero from "./Hero/Hero";
import Footer from "../../Components/Footer/Footer";
import TextContent from "./TextContent/TextContent";
import JCarousel from "./JCarousel/JCarousel";
import Form from "./Form/DonationForm";
import Qrcodes from "./QRCodes/Qrcodes.jsx";
import { Helmet } from "react-helmet-async";

const Radhastami2025 = () => {
  const eventSchema = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "Sri Radhastami Celebrations 2025",
    startDate: "2025-08-31T10:00:00+05:30",
    endDate: "2025-08-31T14:00:00+05:30",
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    eventStatus: "https://schema.org/EventScheduled",
    location: {
      "@type": "Place",
      name: "ISKCON Vijayawada Sri Sri Radha Syam Sundar Mandir",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "ISKCON Sri Jagannath Mandir, Skew Bridge, Ramalingeswara Nagar",
        addressLocality: "Vijayawada",
        addressRegion: "Andhra Pradesh",
        postalCode: "520013",
        addressCountry: "IN",
      },
    },
    organizer: {
      "@type": "Organization",
      name: "ISKCON Vijayawada",
      url: "https://www.iskconvijayawada.org/",
    },
    description:
      "Sri Radhastami marks the appearance of Srimati Radharani, celebrated with devotional music, prayers, abhishekam, and seva at ISKCON Vijayawada.",
    image: [
      "https://www.iskconvijayawada.org/static/media/Sri%20Radhastami_Web_Banner.d292009597a5e5773be3.jpg",
    ],
    offers: {
      "@type": "Offer",
      url: "https://www.iskconvijayawada.org/radhastami2025",
      availability: "https://schema.org/InStock",
      price: "0",
      priceCurrency: "INR",
    },
    performer: {
      "@type": "Organization",
      name: "ISKCON Vijayawada",
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>Sri Radhastami Celebrations 2025 | ISKCON Vijayawada</title>
        <meta
          name="description"
          content="Celebrate Sri Radhastami, the appearance of Srimati Radharani, at ISKCON Vijayawada Sri Sri Radha Syam Sundar Mandir on August 31st, 2025. Join devotees for music, prayers, offerings, and seva, and embark on your spiritual journey in a sacred atmosphere."
        />
        <meta
          name="keywords"
          content="Sri Radhastami, ISKCON Vijayawada, Srimati Radharani, Lord Krishna, devotional celebrations, bhakti, spiritual guidance, Radha Shyam Sundar, Jagannath Baldev Subhadra, seva, Krishna consciousness, temple events, programs, spiritual journey."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Sri Radhastami Celebrations 2025 | ISKCON Vijayawada"
        />
        <meta
          property="og:description"
          content="Celebrate Sri Radhastami, the appearance of Srimati Radharani, at ISKCON Vijayawada Sri Sri Radha Syam Sundar Mandir on August 31st, 2025. Join devotees for music, prayers, offerings, and seva, and embark on your spiritual journey in a sacred atmosphere."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content=" https://www.iskconvijayawada.org/radhastami2025"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Sri Radhastami Celebrations 2025 | ISKCON Vijayawada"
        />
        <meta
          name="twitter:description"
          content="Celebrate Sri Radhastami, the appearance of Srimati Radharani, at ISKCON Vijayawada Sri Sri Radha Syam Sundar Mandir on August 31st, 2025. Join devotees for music, prayers, offerings, and seva, and embark on your spiritual journey in a sacred atmosphere."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/radhastami2025"
        />

        {/* <script type="application/ld+json">
          {`
                    {
                        "@context": "https://schema.org",
                        "@type": "Event",
                        "name": "ISKCON Vijayawada Janmashtami 2025",
                        "alternateName": "Janmashtami Vijayawada",
                        "startDate": "2025-07-27T08:00:00+05:30",
                        "endDate": "2025-07-29T18:00:00+05:30",
                        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
                        "eventStatus": "https://schema.org/EventScheduled",
                        "location": {
                        "@type": "Place",
                        "name": "ISKCON Vijayawada",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "29-12-7, Nakkala Road, Suryaraopeta",
                            "addressLocality": "Vijayawada",
                            "addressRegion": "Andhra Pradesh",
                            "postalCode": "520002",
                            "addressCountry": "IN"
                        }
                        },
                        "image": [
                        "https://www.iskconvijayawada.org/wp-content/uploads/2024/06/rathyatra-banner.webp"
                        ],
                        "description": "Join us for the grand ISKCON Vijayawada Ratha Yatra 2025 – a spiritual procession of Lord Jagannath, Baladev, and Subhadra Devi through the streets of Vijayawada. Kirtan, prasadam, and devotional festivities await.",
                        "organizer": {
                        "@type": "Organization",
                        "name": "ISKCON Vijayawada",
                        "url": "https://www.iskconvijayawada.org"
                        },
                        "offers": {
                        "@type": "Offer",
                        "url": "https://www.iskconvijayawada.org/rathyatra",
                        "price": "0",
                        "priceCurrency": "INR",
                        "availability": "https://schema.org/InStock",
                        "validFrom": "2025-06-15T00:00:00+05:30"
                        },
                        "performer": {
                        "@type": "Organization",
                        "name": "ISKCON Devotees"
                        }
                    }
                    `}
        </script> */}

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(eventSchema)}
        </script>

        {/* Google Tag (gtag.js) */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-17470820924"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-17470820924');
          `}
        </script>
      </Helmet>
      <Hero />
      <TextContent />
      <JCarousel />
      <Form />
      <Qrcodes />
      <Footer />
    </div>
  );
};

export default Radhastami2025;
